import { isFunction } from '@/utils/is'
import type { SVGPathCommand } from '@/utils/svg/types';
import type { SVGAttributes } from 'vue'
import type { FunctionalComponent } from 'vue'

export type IconFactor = string | FunctionalComponent | SVGIcon | SVGPathCommand;

export type SVGIcon = Omit<Partial<SVGAttributes>, 'style' | 'onClick'> & {
  src: IconFactor | IconFactor[];
  source?: IconFactor | IconFactor[];
  size?: number | string
  width?: number| string;
  height?: number | string;
  flipHori?: boolean
  flipVert?: boolean
  rotationDeg?: number;
  excludeFillTags?: string[];
  excludeStrokeTags?: string[];
  noNewAttributes?: boolean;
  color?: string;
  pathOptions?: Array<Partial<Omit<SVGIcon, 'pathOptions'>>>
  cacheKey?: string;
  fallback?: FunctionalComponent<any>
}

export const isSVGIconObject = (x: any): x is SVGIcon => {
  if (!x) return false
  return typeof x === 'object' && !!x.src
}

export const isSVGIconObjectArray = (x: any): x is Array<SVGIcon> => {
  if (!Array.isArray(x)) return false;
  return x.filter(it => isSVGIconObject(it) === true).length >= x.length;
}

export const getIconProps = (icon: IconFactor): Partial<SVGIcon> => {
  if (isFunction(icon)) {
    return (icon as any).iconProps || {}
  }
  if (isSVGIconObject(icon)) {
    return icon
  }

  return {}
}
